import React, { useContext } from 'react'
import { AuthContext } from '../AuthContext'
import { BrowserRouter, Navigate, Route, Router, Routes } from 'react-router-dom';
import LoginPage from '../LoginPage';




import AppLayout from '../AppLayout';
import OrganizationUserSidebar from '../sidebars/OrganizationUserSidebar';
import RequireAuth from '../RequireAuth';

import UserProfile from '../profiles/UserProfile';
import OrganizationUserRoutes from './OrganizationUserRoutes';






const DocsPlatformRoutes = () => {

  const { user } = useContext(AuthContext);




  if (user === null) {

    return null;
  }

  return (



    <Routes>


      {/* <Route path="/home" element={<HomePage />} /> */}
      {/* <Route path="/addresses" element={<AddressPage />} /> */}


        <Route
        path="/user/profile"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <UserProfile />
            </AppLayout>
          </RequireAuth>
        }
      />


     
    


     



        <Route path="/docs/*" element={<OrganizationUserRoutes />} />
      
     




    </Routes>


  )
}

export default DocsPlatformRoutes
